export class BreadCrumb {
    constructor(public  route: any[],public  id: number,public  name: string,public  view?: string ) {

    }
}
